import React, { useEffect, useState } from 'react';
import { washHub } from 'store/slices';
import { useWashHubListener } from 'hooks';
import { WashhubInventoryProps } from './WashhubInventory.props';
import WashhubInventoryView from './WashhubInventory.view';
import { useQuery } from 'react-query';
import { fetchWashHubInventoryCountList } from 'api/washhub';

const WashhubInventoryContainer = (_: WashhubInventoryProps) => {
  const [page, setPage] = useState<number>(1);
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [`fetch-hub-inventory-count`, page, washHubId];

  const queryFn = () =>
    fetchWashHubInventoryCountList({
      page,
      limit: 10,
      washHub: washHubId,
    });

  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  const { data, isLoading, isFetching } = useQuery(queryKey, queryFn, options);

  useWashHubListener(() => {
    setPage(1);
  });

  const WashhubInventory = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  const _props = {
    washHubId,
    WashhubInventory,
    pagination,
    isLoading: isLoading || isFetching,
  };

  return <>{<WashhubInventoryView {..._props} />}</>;
};

export default WashhubInventoryContainer;
